import React from 'react'
import styled from 'src/styles'
import { ComponentStyleProps } from 'src/types'
import LogoCreaith from 'src/images/logo-creaith.svg'

type Props = {
  display?: 'block' | 'inline-block'
  width?: number
} & ComponentStyleProps

export const AppLogo: React.FC<Props> = (props) => {
  return <ScImg {...props} src={LogoCreaith} alt="株式会社Creaith" />
}

const ScImg = styled.img<Props>`
  height: auto;
  display: ${({ display = 'inline-block' }) => display};
  width: ${({ width = 160 }) => width}px;
`
